import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SitePage, PageHead } from "./SiteChrome";

const VALUES = [
  { t: "Clinical truth first", d: "Every reasoning pathway reflects real chairside experience — not engineering guesses about medicine." },
  { t: "Explainability over magic", d: "If the system cannot show its reasoning, it does not ship." },
  { t: "The clinician decides", d: "CamelionAI supports professional judgment. It never replaces it." },
  { t: "Adaptation", d: "Healthcare changes constantly. The platform is built to change with it — the chameleon is the point." },
];

export default function AboutPage() {
  return (
    <SitePage testId="about-page">
      <PageHead
        label="About CamelionAI"
        title={<>Built by a prosthodontist. <span className="grad-text">For every clinician.</span></>}
        lede="CamelionAI is an adaptive healthcare intelligence company building clinical, medical, and revenue platforms unified by one reasoning engine."
      />

      <div className="founder-grid sp-about-grid">
        <div>
          <p className="founder-body">
            CamelionAI was founded by <strong>Dr. Ronik Seecharan, DMD</strong> — a practicing prosthodontist with
            30 years of clinical experience and an Advanced Certificate in Prosthodontics from Tufts University
            School of Dental Medicine. After three decades at the chair, one conviction remained: the tools
            clinicians deserve must be built from clinical reasoning outward, not bolted on from the outside.
          </p>
          <p className="founder-body">
            That conviction became three platforms — <strong>ProsthoAI</strong> for dental clinical decision support,
            <strong> ZidaMD</strong> for physician reasoning, and <strong>ReimbursePro</strong> for revenue
            intelligence — orchestrated by CamelionAI, the layer that preserves what the organisation learns and
            makes it available to every decision that follows.
          </p>
          <p className="founder-body">
            <strong>Built from real clinical experience and strengthened by thoughtful engineering.</strong>
          </p>
          <div className="credentials-row">
            <span>Patent Pending USPTO</span><span className="dot">·</span>
            <span>30 Years Clinical</span><span className="dot">·</span>
            <span>Tufts University</span><span className="dot">·</span>
            <span>Boca Raton, FL</span>
          </div>
        </div>
        <div className="founder-visual">
          <div className="founder-portrait">
            <img src="/images/founder.png" alt="Dr. Ronik Seecharan, DMD — Founder & CEO, CamelionAI" />
          </div>
          <div className="quote-card" style={{ width: "100%" }}>
            <span className="quote-mark">&ldquo;</span>
            <p className="quote-text">This is the tool I wished I had.</p>
            <div className="quote-attr">
              <div><strong>Dr. Ronik Seecharan, DMD</strong></div>
              <div>Prosthodontist &amp; Founder</div>
            </div>
          </div>
        </div>
      </div>

      <div className="sp-section-label">
        <div className="section-label"><span className="label-line" /> What we believe</div>
      </div>
      <div className="trust-grid">
        {VALUES.map((v) => (
          <div className="trust-card" key={v.t}>
            <div>
              <div className="trust-card-title">{v.t}</div>
              <div className="trust-card-sub">{v.d}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="sp-cta-strip">
        <p>Want to be part of the beta or explore a partnership?</p>
        <Link to="/contact" className="btn-primary sp-btn" data-testid="about-contact-cta">
          Contact us <ArrowRight size={15} />
        </Link>
      </div>
    </SitePage>
  );
}
